// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CloseShiftModal_modalOverlay__b4pUF {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Окно */
.CloseShiftModal_modal__PkvLi {
  background: #fff;
  padding: 30px 25px;
  border-radius: 16px;
  width: 380px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: CloseShiftModal_fadeIn__fLWSh 0.25s ease;
}

.CloseShiftModal_modal__PkvLi h2 {
  font-size: 22px;
  margin-bottom: 10px;
  color: #333;
}

.CloseShiftModal_modal__PkvLi p {
  font-size: 14px;
  color: #555;
  margin: 6px 0;
}

.CloseShiftModal_subText__1ro-J {
  margin-top: 10px;
}

/* Сумма */
.CloseShiftModal_amountDisplay__YNypx {
  background: #f8f9fa;
  border: 2px solid #ddd;
  border-radius: 10px;
  font-size: 26px;
  font-weight: bold;
  padding: 15px;
  margin: 20px auto;
  text-align: right;
  color: #222;
}

/* NumPad */
.CloseShiftModal_numPad__MJo9E {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin: 20px 0;
}

.CloseShiftModal_numPad__MJo9E button {
  background: #f1f3f5;
  border: none;
  border-radius: 12px;
  padding: 18px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: 0 3px 6px rgba(0,0,0,0.1);
}

.CloseShiftModal_numPad__MJo9E button:hover {
  background: #e0e4e7;
  transform: scale(1.05);
}

.CloseShiftModal_clearBtn__v72HV {
  background: #ffe3e3 !important;
  color: #c92a2a;
}

/* Кнопки */
.CloseShiftModal_modalActions__n4qXn {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

.CloseShiftModal_modalActions__n4qXn button {
  flex: 1 1;
  padding: 14px 0;
  margin: 0 5px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.CloseShiftModal_confirm__dIZ5d {
  background: #28a745;
  color: white;
}

.CloseShiftModal_confirm__dIZ5d:hover {
  background: #218838;
}

.CloseShiftModal_exit__VF-HT {
  background: #dee2e6;
  color: #333;
}

.CloseShiftModal_exit__VF-HT:hover {
  background: #ced4da;
}

@keyframes CloseShiftModal_fadeIn__fLWSh {
  from {
    opacity: 0;
    transform: translateY(-15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.CloseShiftModal_cancel__r-PrZ {
  margin-top: 16px;
  width: 100%;
  height: 44px;

  background: transparent;
  border: 1px solid #d0d0d0;
  border-radius: 8px;

  color: #555;
  font-size: 14px;
  font-weight: 500;

  cursor: pointer;
  transition: all 0.2s ease;
}

.CloseShiftModal_cancel__r-PrZ:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #bdbdbd;
}

.CloseShiftModal_cancel__r-PrZ:active:not(:disabled) {
  background: #eeeeee;
}

.CloseShiftModal_cancel__r-PrZ:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/CloseShiftModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,mDAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;;EAEZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;;EAElB,WAAW;EACX,eAAe;EACf,gBAAgB;;EAEhB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Окно */\n.modal {\n  background: #fff;\n  padding: 30px 25px;\n  border-radius: 16px;\n  width: 380px;\n  text-align: center;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.2);\n  animation: fadeIn 0.25s ease;\n}\n\n.modal h2 {\n  font-size: 22px;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.modal p {\n  font-size: 14px;\n  color: #555;\n  margin: 6px 0;\n}\n\n.subText {\n  margin-top: 10px;\n}\n\n/* Сумма */\n.amountDisplay {\n  background: #f8f9fa;\n  border: 2px solid #ddd;\n  border-radius: 10px;\n  font-size: 26px;\n  font-weight: bold;\n  padding: 15px;\n  margin: 20px auto;\n  text-align: right;\n  color: #222;\n}\n\n/* NumPad */\n.numPad {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin: 20px 0;\n}\n\n.numPad button {\n  background: #f1f3f5;\n  border: none;\n  border-radius: 12px;\n  padding: 18px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  box-shadow: 0 3px 6px rgba(0,0,0,0.1);\n}\n\n.numPad button:hover {\n  background: #e0e4e7;\n  transform: scale(1.05);\n}\n\n.clearBtn {\n  background: #ffe3e3 !important;\n  color: #c92a2a;\n}\n\n/* Кнопки */\n.modalActions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 25px;\n}\n\n.modalActions button {\n  flex: 1;\n  padding: 14px 0;\n  margin: 0 5px;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.confirm {\n  background: #28a745;\n  color: white;\n}\n\n.confirm:hover {\n  background: #218838;\n}\n\n.exit {\n  background: #dee2e6;\n  color: #333;\n}\n\n.exit:hover {\n  background: #ced4da;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-15px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.cancel {\n  margin-top: 16px;\n  width: 100%;\n  height: 44px;\n\n  background: transparent;\n  border: 1px solid #d0d0d0;\n  border-radius: 8px;\n\n  color: #555;\n  font-size: 14px;\n  font-weight: 500;\n\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cancel:hover:not(:disabled) {\n  background: #f5f5f5;\n  border-color: #bdbdbd;\n}\n\n.cancel:active:not(:disabled) {\n  background: #eeeeee;\n}\n\n.cancel:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `CloseShiftModal_modalOverlay__b4pUF`,
	"modal": `CloseShiftModal_modal__PkvLi`,
	"fadeIn": `CloseShiftModal_fadeIn__fLWSh`,
	"subText": `CloseShiftModal_subText__1ro-J`,
	"amountDisplay": `CloseShiftModal_amountDisplay__YNypx`,
	"numPad": `CloseShiftModal_numPad__MJo9E`,
	"clearBtn": `CloseShiftModal_clearBtn__v72HV`,
	"modalActions": `CloseShiftModal_modalActions__n4qXn`,
	"confirm": `CloseShiftModal_confirm__dIZ5d`,
	"exit": `CloseShiftModal_exit__VF-HT`,
	"cancel": `CloseShiftModal_cancel__r-PrZ`
};
export default ___CSS_LOADER_EXPORT___;
